<template>
    <div class="container">
        <div class="col-md-12">
            <h2> {{ labels.title }} </h2>
        </div>
        <div>
            <b-container>
                <b-row id="home-buttons" v-for="subMenu in listaSubMenu" :key="subMenu.id">
                    <b-col md="4" class="p-2" col="3" @click="goToRoute(subMenu.ruta)">
                        <md-card md-with-hover>
                            <md-ripple>
                                <md-card-header>
                                    <div class="md-title-tarjeta">
                                        <span>{{ subMenu.nombre }}</span>
                                    </div>
                                </md-card-header>
                            </md-ripple>
                        </md-card>
                    </b-col>
                    <b-col md="8" class="p-2" col="3" @click="goToRoute(subMenu.ruta)">
                        <md-card md-with-hover>
                            <md-ripple>
                                <md-card-header>
                                    <div class="md-title-tarjeta">
                                        <span>{{ subMenu.descripcion }}</span>
                                    </div>
                                </md-card-header>
                            </md-ripple>
                        </md-card>
                    </b-col>
                </b-row>
            </b-container>
        </div>
    </div>
</template>
<script>
import SubMenu from '../../services/SubMenu';
    export default {
        name:"Parametrizacion",

        data: () => ({
            listaSubMenu : []
        }),

        computed:{
            labels(){
                if (this.$store.state._language == "es-ES") {
                    return {
                        title: "Cierres",
                    }
                }else{
                    return {
                        title: "Closures",
                    }
                }
            }
        },
        methods:{
            goToRoute(page){
                this.$router.push({path: page })
            }
        },
        mounted(){
            SubMenu.subMenuByMenuByRol(this.$route.name,this.$store.state.userRole)
            .then((res) => {
                // console.log(res.data.submenus)
                // console.log(this.$store)
                this.listaSubMenu = res.data.submenus
            })
            .catch((err) => { console.log(err)})
        }
    }

</script>
<style src="../main.css"></style>
